window.addEventListener("load", function () {

    var externalLinks = document.querySelectorAll('.external-link')
    for (let index = 0; index < externalLinks.length; index++) {
        var link = externalLinks[index]
        
        link.addEventListener('click', function() {
            var tcObject = { 
                url: this.href,
                eventType: 'bankueberleitung',
                eventValue: this.dataset.bankname
            }

            tC.event.link(this, tcObject);
        })
    }

}, false);
